import { EditDataPribadiPayload } from "../../../../models/DataPribadi";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { dataPribadiKey } from "../../queries/DataPribadi/useFetchDataPribadi";
import getQueryClient from "../../queryClient";

export async function editDataPribadi(data: EditDataPribadiPayload) {
  const res = await ApiClient.put(`/EditDataPribadi`, data);
  return res.data;
}

export const useEditDataPribadi = mutationWrapper(editDataPribadi, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(dataPribadiKey);
  },
});
